export default class FormFilter {
    static isPhone(rule, value, callback) {
        if (!value) {
            callback(new Error("手机号不能为空"))
        } else if (!/^1[123456789]\d{9}$/.test(value)) {
            callback(new Error("请输入正确的手机号"))
        } else {
            callback()
        }
    }
}